import { ChakraHighlightSelection } from 'app/components/Core/ChakraHighlightSelection';
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters';
import { RefObject } from 'react';
import { SingleValue } from 'chakra-react-select';

export const formatOptionLabel = <Option extends {}>(
  getOptionLabel: (option: SingleValue<Option> | null | undefined) => string
) => (option: Option, { inputValue }) => (
  <ChakraHighlightSelection
    inputValue={inputValue}
    highlight={getOptionLabel(option)}
  />
);

export const filterOption = <Option extends {}>(
  getOptionLabel: (option: Option | null | undefined) => string,
  addFilterOption: (option: Option, inputValue: string) => boolean,
  filter: RefObject<boolean>
) => (option: FilterOptionOption<Option>, inputValue: string) => {
  const label = getOptionLabel(option.data);
  const labelMatch = label.toLowerCase().includes(inputValue.toLowerCase());

  return (
    !filter.current || labelMatch || addFilterOption(option.data, inputValue)
  );
};
